import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  useTheme,
} from "@mui/material";
import Header from "components/Header";
import { useDispatch, useSelector } from "react-redux";
import { Delete, Groups2Outlined } from "@mui/icons-material";
import MUIDataTable from "mui-datatables";
import FlexBetween from "components/FlexBetween";
import {
  fetchAddNotifikasi,
  fetchDeleteNotifikasi,
  fetchListNotifikasi,
} from "state/notifikasiActions";
import moment from "moment";
import "moment/locale/id";
import AddNotifikasiModal from "components/Modals/AddNotifikasiModal";
import FloatingAlert from "components/FloatingAlert";
import { setMessage, setStatus } from "state";
import KonfirmasiModal from "components/Modals/KonfirmasiModal";
import { BASEURL } from "api/axiosInstance";
moment.locale("id");

const Notifikasi = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [openAdd, setOpenAdd] = useState(false);
  const [openKonfirmasi, setOpenKonfirmasi] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [openImagePreview, setOpenImagePreview] = useState(false);
  const [previewImageUrl, setPreviewImageUrl] = useState("");

  const { status, message } = useSelector((state) => state.global);
  const { list_notifikasi } = useSelector((state) => state.notifikasi);

  useEffect(() => {
    dispatch(fetchListNotifikasi());
  }, []);

  const handleSelectedData = (id) => {
    let currentSelectedData = list_notifikasi.find(
      (item) => item.id_notifikasi === id,
    );
    setSelectedData(currentSelectedData);
  };

  const handleDelete = () => {
    dispatch(fetchDeleteNotifikasi(selectedData.id_notifikasi));
    setOpenKonfirmasi(false);
    setSelectedData(null);
  };

  const handleCloseSnackbar = () => {
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
    dispatch(fetchListNotifikasi());
  };

  const handleSubmitNotifikasi = (formData) => {
    console.log("formData: ", formData);

    const reqData = new FormData();
    reqData.append("title", formData.judul);
    reqData.append("body", formData.isi);

    const url = formData.url;
    if (url) {
      reqData.append("url", url);
    }

    const gambar = formData.gambar;
    if (gambar) {
      reqData.append("gambar", gambar);
    }
    // Debug FormData
    console.log("--- DEBUG REQDATA ---");
    for (let [key, value] of reqData.entries()) {
      if (key === "gambar" && value && typeof value === "object") {
        console.log(`${key}: [File]`, {
          name: value.name,
          type: value.type,
          size: value.size,
        });
      } else {
        console.log(`${key}: ${value}`);
      }
    }
    console.log("---------------------");
    dispatch(fetchAddNotifikasi(reqData));
  };

  const columnsKaryawan = [
    {
      name: "id_notifikasi",
      options: {
        filter: true,
        sort: false,
        display: false,
      },
    },
    {
      name: "judul_notifikasi",
      label: "Judul Notifikasi",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "isi_notifikasi",
      label: "Isi Notifikasi",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "waktu_notifikasi",
      label: "Waktu Dibuat",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          return moment(value).format("DD MMMM YYYY - HH:mm");
        },
      },
    },
    {
      name: "gambar",
      label: "Gambar Notifikasi",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const gambarNotif = tableMeta.rowData[4];
          console.log("gambarnotif: ", gambarNotif);

          if (!gambarNotif) {
            return "-";
          }
          return (
            <Box
              component="img"
              src={gambarNotif}
              alt="Foto QR"
              sx={{
                width: 40,
                height: 40,
                objectFit: "cover",
                cursor: "pointer",
                borderRadius: 1,
                border: `1px solid ${theme.palette.divider}`,
              }}
              onClick={() => {
                setPreviewImageUrl(gambarNotif);
                setOpenImagePreview(true);
              }}
            />
          );
        },
      },
    },
    {
      name: "url",
      label: "Link Notifikasi",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const link = tableMeta.rowData[5];

          if (!link || link === "-") {
            return "-";
          }

          return (
            <Button
              variant="outlined"
              size="small"
              color="error"
              href={link}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textTransform: "none" }}
            >
              Buka Link
            </Button>
          );
        },
      },
    },
    {
      name: "aksi",
      label: "Aksi",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const id = tableMeta.rowData[0];
          return (
            <>
              <IconButton
                color="error"
                onClick={() => {
                  setOpenKonfirmasi(true);
                  handleSelectedData(id);
                }}
              >
                <Delete />
              </IconButton>
            </>
          );
        },
      },
    },
  ];

  const options = {
    selectableRows: "none",
    filterType: "dropdown",
    fixedHeader: false,
    fixedSelectColumn: false,
    responsive: "standard",
    rowsPerPageOptions: [30, 60, list_notifikasi.length],
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: (numberOfRows) => setRowsPerPage(numberOfRows),
  };

  return (
    <Box m="1.5rem 2.5rem">
      <FlexBetween>
        <Header
          title="Notifikasi"
          subtitle="Daftar notifikasi yang akan dikirim ke perangkat karyawan."
        />

        <Box>
          <Button
            sx={{
              backgroundColor: theme.palette.secondary.light,
              color: theme.palette.background.alt,
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
              "&:hover": {
                backgroundColor: theme.palette.secondary.light, // Tetap sama dengan warna awal
              },
            }}
            onClick={() => setOpenAdd(true)}
          >
            <Groups2Outlined sx={{ mr: "10px" }} />
            Tambah Notifikasi
          </Button>
        </Box>
      </FlexBetween>
      <Box
        mt="40px"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: theme.palette.primary.light,
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: theme.palette.background.alt,
            color: theme.palette.secondary[100],
            borderTop: "none",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${theme.palette.secondary[200]} !important`,
          },
        }}
      >
        <MUIDataTable
          title={""}
          data={list_notifikasi}
          columns={columnsKaryawan}
          options={options}
        />
        <AddNotifikasiModal
          open={openAdd}
          onClose={() => setOpenAdd(false)}
          onSubmit={(value) => handleSubmitNotifikasi(value)}
        />
        <FloatingAlert
          open={message.length > 0}
          onClose={handleCloseSnackbar}
          message={message}
          severity={status === "failed" ? "error" : status}
        />
        <KonfirmasiModal
          titleType={"Hapus"}
          subtitleType={"Menghapus"}
          dataWillProses={selectedData?.judul_notifikasi}
          open={openKonfirmasi}
          onClose={() => setOpenKonfirmasi(false)}
          onSubmit={() => handleDelete()}
        />
        {/* Image Preview Modal */}
        <Dialog
          open={openImagePreview}
          onClose={() => setOpenImagePreview(false)}
          maxWidth="sm"
          fullWidth
        >
          <DialogContent
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: 2,
              backgroundColor: theme.palette.background.default,
            }}
          >
            <Box
              component="img"
              src={previewImageUrl}
              alt="Foto QR Preview"
              sx={{
                maxWidth: "100%",
                maxHeight: "70vh",
                objectFit: "contain",
              }}
            />
          </DialogContent>
        </Dialog>
      </Box>
    </Box>
  );
};

export default Notifikasi;
